import styled from "styled-components"

import Icon from "@irati/ui/src/Icon"

export const WalletIcon = styled(Icon)`
  margin-right: 10px;
  flex-shrink: 0;
`
